import { render, staticRenderFns } from "./CouponItem.vue?vue&type=template&id=26024476&"
import script from "./CouponItem.vue?vue&type=script&lang=js&"
export * from "./CouponItem.vue?vue&type=script&lang=js&"
import style0 from "./CouponItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports